module.exports = __webpack_public_path__ + "static/img/contentLeftImg4.d7063ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentLeftImg4.png
// module id = aXFw
// module chunks = 2